<template>
	<b-row>
		<b-col cols="12">
			<b-card class="position-relative" style="height: calc(100vh - 15rem)">
				<b-tabs fill>
					<b-tab active title="监控摄像头">
						<b-table :items="items" hover striped></b-table>
						<b-pagination v-model="currentPage" :total-rows="rows" align="right" class="position-absolute" first-number hide-goto-end-buttons last-number next-class="next-item" prev-class="prev-item" style="bottom: 0; right: 1rem" />
					</b-tab>
					<b-tab title="门禁"></b-tab>
					<b-tab title="入侵警报器"></b-tab>
				</b-tabs>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import { reactive, toRefs } from "@vue/composition-api";

	export default {
		name: "index",
		setup() {
			const data = reactive({
				items: [
					{ age: 40, first_name: "Dickerson", last_name: "Macdonald" },
					{ age: 21, first_name: "Larsen", last_name: "Shaw" },
					{ age: 89, first_name: "Geneva", last_name: "Wilson" },
					{ age: 38, first_name: "Jami", last_name: "Carney" },
				],
				currentPage: 1,
				rows: 1,
			});
			return {
				...toRefs(data),
			};
		},
	};
</script>

<style scoped></style>
